angular.module("digitalLeasing.module")
  .component("distancePolicy", {
    templateUrl: "ng/components/digitalLeasing/distancePolicy/distancePolicy.view.html",
    controllerAs: "accordionDistancePolicyCtrl",
    bindings: {
      model: '='
    },
    controller: function ($modalService) {
      var self = this;



      self.$onInit = function () {
        jQuery(".alb-scroll.recovery-scroll").mCustomScrollbar("scrollTo", 0); //posiziona la scollBar in top ad ogni cambio vista
        self.venditaDistanzaPolizza = self.model.venditaDistanzaPolizza;
        self.linkOne="https://www.albaleasing.eu/";
      };




      self.handleChange = function () {

        $modalService.openModal("distance-modal");
        
        console.log("Changes made to the model", self.model);

      };

    }
  });